module.exports = {"522729001":"长寨街道","522729101":"广顺镇","522729103":"摆所镇","522729104":"代化镇","522729105":"白云山镇","522729106":"鼓扬镇","522729209":"敦操乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522729.json
// module id = 2534
// module chunks = 0